// export const s3BucketURL = `https://s3.eu-west-1.amazonaws.com/assets${
// 	process.env.REACT_APP_ENVIRONMENT === 'production' ? '' : '-dev'
// }.cv30.co`
export const s3BucketURL = 'https://pub-489edbd5db394edebd2d48530efb228e.r2.dev'
export const articlesFolder = 'articles'
export const profilesFolder = 'users' //'profiles'
export const storiesFolder = 'stories'
export const teamsFolder = 'teams'
export const companiesFolder = 'companies'
export const jobsFolder = 'jobs'
export const adsFolder = 'promo'
